import Toggle from './toggle'

Toggle.install = vue => {
  vue.component(Toggle.name, Toggle)
}

export default Toggle
